var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91 9.9C5.85957 9.9 7.44 8.31957 7.44 6.37C7.44 4.42043 5.85957 2.84 3.91 2.84C1.96044 2.84 0.380001 4.42043 0.380001 6.37C0.380001 8.31957 1.96044 9.9 3.91 9.9Z",
    fill: "#B44755"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04 21.77L16.35 15.7L31.05 19.66L17.85 25.96L3.04 21.77Z",
    fill: "#DDD7D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12 16.73L16.43 10.67L31.13 14.63L17.93 20.93L3.12 16.73Z",
    fill: "#BFBEBE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01 12.14L16.32 6.07L31.02 10.04L17.82 16.33L3.01 12.14Z",
    fill: "#DDD7D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/group2.8d38b4ef8df3b272653f5f113da39556.svg";
export { ForwardRef as ReactComponent };